import { ReactNode, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUserProfile } from '~/hooks/useCurrentUserProfile';
import { buildPermissionSet, hasAnyPermission } from '~/lib/permissions';

type RequirePermissionProps = {
  children: ReactNode;
  /** User must have at least one of these permissions (normalized match). */
  requiredAny: readonly string[];
  fallbackPath?: string;
};

export function RequirePermission({
  children,
  requiredAny,
  fallbackPath = '/app/dashboard',
}: RequirePermissionProps) {
  const { data } = useCurrentUserProfile();
  const set = useMemo(() => buildPermissionSet(data?.permissions), [data?.permissions]);

  if (!hasAnyPermission(set, requiredAny)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
}
